import { render, staticRenderFns } from "./TestSocketEvents.vue?vue&type=template&id=9db73b0e&scoped=true&"
import script from "./TestSocketEvents.vue?vue&type=script&lang=js&"
export * from "./TestSocketEvents.vue?vue&type=script&lang=js&"
import style0 from "./TestSocketEvents.vue?vue&type=style&index=0&id=9db73b0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db73b0e",
  null
  
)

export default component.exports